import React from 'react'
import {
  ModeleReferentielFournisseurPOT,
  modeleReferentielFournisseurPOTInitValues,
} from '../../../components/Models'
import {useNavigate} from 'react-router-dom'
import {createFournisseurPOT} from '../../../components/requests'
import {ReferentielFournisseurPOTForm} from './components/ReferentielFournisseurPOTForm'
import {useLocation} from "react-router";

type LocationState = {
  allFournisseursPOT: any
}

const ReferentielFournisseurPOTAddPage = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const state = location.state as LocationState | null

  const submitForm = async (
    fieldsToUpdate: Partial<ModeleReferentielFournisseurPOT>,
    callback
  ): Promise<void> => {
    const updatedData = Object.assign(
      {...modeleReferentielFournisseurPOTInitValues},
      fieldsToUpdate
    )

    let requestOk = false
    try {
      const fournisseurPOTRequest = await createFournisseurPOT(updatedData)
      if (fournisseurPOTRequest?.status === 200) {
        if (
          fournisseurPOTRequest?.data?.id !== undefined &&
          fournisseurPOTRequest?.data?.id !== null
        ) {
          requestOk = true
          navigate(`/referentiel-fournisseur-pot/liste`)
        }
      }
    } catch (ex) {
      console.error(ex)
    } finally {
      callback()
    }
  }

  return (
    <div className='card mb-5 mb-xl-10'>
      <div className='card-header border-0'>
        <div className='card-title m-0'>
          <h3 className='fw-bolder m-0'>Créer un fournisseur POT</h3>
        </div>
      </div>

      <div>
        <ReferentielFournisseurPOTForm
          fournisseurPOTId={null}
          data={modeleReferentielFournisseurPOTInitValues}
          submitForm={submitForm}
          allFournisseursPOT={state?.allFournisseursPOT}
        />
      </div>
    </div>
  )
}

export default ReferentielFournisseurPOTAddPage
